import styled from 'styled-components';

import { Title } from '@xsolla/ui-core';

export const StyledSubtitle = styled.p`
  text-align: center;
`;

export const StyledTitle = styled(Title)`
  margin-top: 40px;
`;
